import React, { useState } from 'react'
import PropTypes from "prop-types";
import GalleryImage from './GalleryImage';
import './style.css';
import { Link } from 'react-router-dom';

const LoadMoreImage = (props) => {
    
    // const [imgCount, setImgCount] = useState(4); 
    const [images] = useState(props?.images)
    const openImageView = (img, eventName)=>{
        props.openImageViewer(img, eventName)
    }
    return (
        <>
    {/* <button style={{position: 'absolute',left: '75%', marginTop:'2%', background:'none', border:'none'}}
            onClick={()=>setImgCount(prevCount=>prevCount+5)}>View More</button> */}
            {images.slice(0, 5).map((img,i) => (
                <div onClick ={()=>openImageView(img, props.eventName)} key={img}>
                    <GalleryImage
                        width="200"
                        // style={{ margin: "2px" }}
                        alt=""
                        eventName={props.eventName} imagefileName={img} />
                       {i==4 && <Link to={`/eventgallery/${props.eventName}`} className="viewMore" >View More</Link>}
                </div>
            ))}
        </>
    )
}

export default LoadMoreImage;

LoadMoreImage.propTypes = {
    images: PropTypes.array,
    eventName:PropTypes.string,
    openImageViewer:PropTypes.func
}
